import { Injectable } from "@angular/core";
import { ErrorInterceptor } from "./ErrorInterceptor";
import { HttpClient } from "@angular/common/http";


declare let ENDPOINT_LUDYAPI: string;
declare let NAMESPACE_LUDYACCOUNT: string;

@Injectable()
export class ProfileHttp {

    constructor(private http: HttpClient,
        private errorInterceptor: ErrorInterceptor) {

    }

    getLoggedUserData(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "biz/agent/myself";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }
    
    editProfileData(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "biz/agent/myself/edit";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }
    
    changePassword(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "biz/agent/myself/security/pwd/edit";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }
    
    editProfileImage(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "biz/agent/myself/profileimage/edit";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }
    
    deleteProfileImage(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "biz/agent/myself/profileimage/delete";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }
}

